import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import Button from '../../buttons/Button';
import Checkbox from '../../forms/Checkbox'
import ComboBox from '../../forms/ComboBox';
import DropDownList from '../../forms/DropDownList';
import withMeta from '../../utils/withMeta';
import LoadingPanel from '../../LoadingPanel';
import * as storage from '../../utils/storage';
import { buildUrl } from '../../utils/helper';
import "./Prava.scss";


const AKT_DATA = [
  { id: 0, name: 'Doplniť práva' },
  { id: 1, name: 'Zaktualizovať práva' },
  { id: 2, name: 'Doplniť a zaktualizovať práva' },
  { id: 3, name: 'Prepísať práva' }
];

const PravaUz = ({ selected, showMsg, db, meta }) => {
  const [state, setState] = useState({
    isOpen: false,
    managedUsers: [],
    user: null,
    akt: AKT_DATA[0],
    mnu: true,
    frm: true,
    frmpod: true,
    tl: true,
    isLoading: false,
    currentUserUro: null
  });

  useEffect(() => {
    const getSprav = async () => {
      const managedUsers = await meta.getSprav(db);
      setState(prevState => ({ ...prevState, managedUsers }));
    };

    const getCurrentUserUro = async () => {
      const user = storage.getUser();
      const res = await meta.get("IUz", user.I_UZ, db);
      const currentUserUro = res?.Data?.Uro?.IUro;
      setState(prevState => ({ ...prevState, currentUserUro }));
    };

    getCurrentUserUro();
    getSprav();
    // eslint-disable-next-line
  }, [db]);

  const handleOpen = () => {
    setState(prevState => ({ ...prevState, isOpen: true }));
  }

  const handleClose = () => {
    setState(prevState => ({ ...prevState, isOpen: false }));
  }

  const handleConfirm = async () => {
    setState(prevState => ({ ...prevState, isLoading: true }));
    try {
      const data = selected.map(x => ({
        iUz: state.user?.IUz,
        iUz2: x.IUz,
        iAkt: state.akt.id,
        mnu: state.mnu,
        frm: state.frm,
        frmpod: state.frmpod,
        tl: state.tl
      }));
      await meta.setPravaUz(data, db);
      showMsg('Akcia kopírovania práv prebehla úspešne');
    } catch (error) {
      showMsg(error.message, 'error');
    }
    setState(prevState => ({ ...prevState, isOpen: false, isLoading: false }));
  }

  const handleChange = (name, value) => {
    setState(prevState => ({ ...prevState, [name]: value }));
  }

  const buildDescription = () => {
    if (!state.user) return null;

    switch (state.akt.id) {
      case 0:
        return `Používateľom vybraným v mriežke sa doplnia chýbajúce práva voči právam používateľa ${state.user.NUz}`;
      case 1:
        return `Používateľom vybraným v mriežke sa zaktualizujú existujúce práva podľa práv používateľa ${state.user.NUz} okrem práv,ktoré majú zaškrtnutý príznak "Zamknutie nastavenia práva"`;
      case 2:
        return `Používateľom vybraným v mriežke sa doplnia chýbajúce práva voči právam používateľa ${state.user.NUz} a zaktualizujú sa existujúce práva podľa práv používateľa ${state.user.NUz} okrem práv, ktoré majú zaškrtnutý príznak "Zamknutie nastavenia práva"`;
      case 3:
        return `Používateľom vybraným v mriežke sa odstránia všetky existujúce práva a nastavia sa všetky práva podľa používateľa ${state.user.NUz}`;
      default:
        return null;
    }
  }

  const disabled = selected.some(x => x.Zrus === true || x.Uro?.IUro < state.currentUserUro);

  return (
    <>
      <Dialog
        isOpen={state.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title='Kopírovanie práv'
        confirmDisabled={!state.user}
      >
        <div id="prava-uz" className="k-form-inline">
          <div className="k-form-field">
            <span className="text-left w-50 title">Práva kopírované od používateľa</span>
            <ComboBox
              name="user"
              data={state.managedUsers || []}
              textField="Picker"
              onChange={handleChange}
              value={state.user}
            />
          </div>
          <div className="k-form-field update">
            <span className="text-left w-50 title">Režim aktualizácie</span>
            <DropDownList
              name="akt"
              data={AKT_DATA}
              textField="name"
              onChange={handleChange}
              value={state.akt}
            />
          </div>
          <div className="k-form-field description">
            {buildDescription()}
          </div>
          <div>
            <Checkbox
              name="mnu"
              label="Zaktualizovať práva na položky menu"
              onChange={handleChange}
              value={state.mnu}
            />
          </div>
          <div>
            <Checkbox
              name="frm"
              label="Zaktualizovať práva na akcie nad formulárom"
              onChange={handleChange}
              value={state.frm}
            />
          </div>
          <div>
            <Checkbox
              name="frmpod"
              label="Zaktualizovať práva na akcie nad podradeným formulárom"
              onChange={handleChange}
              value={state.frmpod}
            />
          </div>
          <div>
            <Checkbox
              name="tl"
              label="Zaktualizovať práva na tlačové zostavy"
              onChange={handleChange}
              value={state.tl}
            />
          </div>
          <LoadingPanel isLoading={state.isLoading} />
        </div>
      </Dialog>
      <Button
        onClick={handleOpen}
        title="Kopírovanie práv"
        imageUrl={buildUrl('assets/icons/toolbar/klon-pouzivatela.svg')}
        disabled={(selected && selected.length === 0) || disabled}
      />
    </>
  );
}

PravaUz.propTypes = {
  selected: PropTypes.array.isRequired,
  showMsg: PropTypes.func.isRequired,
  db: PropTypes.string,
  meta: PropTypes.object
}

export default withMeta(PravaUz);